import React, { useState } from 'react'
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { Button, Grid, Typography, Hidden, Stack, Box, useMediaQuery } from '@mui/material'
import { useNavigate } from 'react-router';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Tooltip } from '@amcharts/amcharts4/.internal/core/elements/Tooltip';
import Image1 from "assets/images/Parallax/SessionD/Fossil Management Fund (10).png";
import Image2 from "assets/images/Parallax/SessionD/Fossil Management Fund (11).png";
import Image3 from "assets/images/Parallax/SessionD/Fossil Management Fund (12).png";
import Image4 from "assets/images/Parallax/SessionD/Fossil Management Fund (13).png";

export const srcset = (image: string, size: number, rows = 1, cols = 1) => {
    return {
        src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
        srcSet: `${image}?w=${size * cols}&h=${size * rows
            }&fit=crop&auto=format&dpr=2 2x`,
    };
}

const GalleryShow = (props: { Gallery, IsPreview }) => {
    const { Gallery, IsPreview } = props;
    const navigate = useNavigate();
    const onGotoPage = () => navigate("/GalleryListImg");

    const LayoutWeb = useMediaQuery('(min-width:1180px)');


    return (
        <React.Fragment>
            {/* normal size */}
            <div className='container-gallery-show'>
                <Grid container alignItems='center' >
                    <Grid item xs={12}>
                        <ImageList
                            variant="quilted"
                            cols={4}
                            rowHeight={"auto"}
                            sx={{
                                gap: "0px !important",
                                margin: '0px'
                            }}
                        >
                            {Gallery.map(item => {
                                const sImg =
                                    <ImageListItem key={item.sImg ? process.env.REACT_APP_API_URL + item.sImg :
                                        item.nNo === 1 ? Image1 : item.nNo === 2 ? Image2 : item.nNo === 3 ? Image3 : Image4} cols={item.ncols || 1} rows={item.nrows || 1}>
                                        <img
                                            {...srcset(item.sImg ? process.env.REACT_APP_API_URL + item.sImg :
                                                item.nNo === 1 ? Image1 : item.nNo === 2 ? Image2 : item.nNo === 3 ? Image3 : Image4, 121, item.nrows, item.ncols)}
                                            alt={item.sGalleryName}
                                            loading="lazy"
                                        />
                                        {/* <div className='relative'> */}
                                        <div className={item.sTextPosition}>
                                            <Typography align={
                                                (() => {
                                                    switch (item.sAlign) {
                                                        case "center":
                                                            return "center";
                                                        case "right":
                                                            return "right";
                                                        case "left":
                                                            return "left";
                                                        case "inherit":
                                                            return "inherit";
                                                        default:
                                                            return "justify";
                                                    }
                                                })()
                                            } 
                                            style={{ fontWeight: 500, color: item.sFontColor ?? "", fontSize: item.sFontSize ?? "16px" }}>{item.sStartDate}</Typography>
                                            <Typography align={
                                                (() => {
                                                    switch (item.sAlign) {
                                                        case "center":
                                                            return "center";
                                                        case "right":
                                                            return "right";
                                                        case "left":
                                                            return "left";
                                                        case "inherit":
                                                            return "inherit";
                                                        default:
                                                            return "justify";
                                                    }
                                                })()
                                            }  style={{ fontWeight: 500, color: item.sFontColor ?? "", fontSize: item.sFontSize  ?? ""}}>{item.sGalleryName}</Typography>
                                            {item.lstDataText != null ? (
                                                <Grid container item md={12} xs={12} >
                                                    {
                                                        item.lstDataText.map((m, index) => {
                                                            return (
                                                                <Grid item md={12} xs={12} key={index}>
                                                                    <Typography align={
                                                (() => {
                                                    switch (item.sAlign) {
                                                        case "center":
                                                            return "center";
                                                        case "right":
                                                            return "right";
                                                        case "left":
                                                            return "left";
                                                        case "inherit":
                                                            return "inherit";
                                                        default:
                                                            return "justify";
                                                    }
                                                })()
                                            } style={{ fontSize: m.sHeadlineSize ?? "", color: m.sHeadlineColor ?? "" }}>{m.sTextGalleryName}</Typography>
                                                                </Grid>
                                                            )
                                                        })
                                                    }
                                                </Grid>
                                            ) : null}
                                        </div>
                                        {/* </div> */}
                                    </ImageListItem>

                                return sImg;
                            }
                            )}
                        </ImageList>
                    </Grid>
                    <Grid item xs={12}>
                        <div className='session-e-container'>
                            <Typography>เพื่อการบริหารจัดการซากดึกดำบรรพ์อย่างยั่งยืน</Typography>
                        </div>
                    </Grid>
                </Grid>
                {LayoutWeb ? (
                    <Grid item container justifyContent={"center"} xs={12}>
                        <div className='gallery-title'>
                            <Typography>photo <br />gallery</Typography>
                            {!IsPreview && <Button variant="text" onClick={() => onGotoPage()} endIcon={<EastRoundedIcon />} >
                                ดูทั้งหมด
                            </Button>
                            }
                        </div>
                    </Grid>
                ) :
                    <Grid item container justifyContent={"center"} xs={12}>
                        <div className='gallery-title1'>
                            <Typography>photo <br />gallery</Typography>
                            {!IsPreview && <Button variant="text" onClick={() => onGotoPage()} endIcon={<EastRoundedIcon />} >
                                ดูทั้งหมด
                            </Button>
                            }
                        </div>
                    </Grid>
                }
            </div>

        </React.Fragment >
    )
}

export default GalleryShow
